import { render, staticRenderFns } from "./AppInfoBar.vue?vue&type=template&id=c377e80c&scoped=true&"
import script from "./AppInfoBar.vue?vue&type=script&lang=js&"
export * from "./AppInfoBar.vue?vue&type=script&lang=js&"
import style0 from "./AppInfoBar.vue?vue&type=style&index=0&id=c377e80c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c377e80c",
  null
  
)

export default component.exports